module.exports = __webpack_public_path__ + "img/banner_vive.3e486dae.png";